import { render, staticRenderFns } from "./AuthLoginIcon.vue?vue&type=template&id=6b3cc2ac"
import script from "./AuthLoginIcon.vue?vue&type=script&lang=js"
export * from "./AuthLoginIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports